import { Add, Remove } from '@mui/icons-material';
import { Box, Button, Grid, LinearProgress, Paper, TextField } from '@mui/material';
import { IParticipantes } from '../../../services/api/action-plan/InternalTraining';
import { useEffect, useState, useCallback } from 'react';

interface ParticipantsProps {
    value: IParticipantes[] | undefined
    onChange: (data: IParticipantes[]) => void,
    smDown: boolean,
}

export const Participants = ({ value, onChange, smDown }: ParticipantsProps) => {

    const [dataSeps, setDataSteps] = useState<IParticipantes[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        if (value) {
            setDataSteps(value);
        } else {
            setDataSteps([]);
        }
        setLoading(false);
    }, [value]);

    const notifyChange = useCallback((newData: IParticipantes[]) => {
        onChange(newData);
    }, [onChange]);

    const handleAdd = () => {
        const newItem: IParticipantes = {};
        setDataSteps(prevDataSteps => {
            const newDataSteps = [...prevDataSteps, newItem];
            setTimeout(() => notifyChange(newDataSteps), 0);
            return newDataSteps;
        });
    };

    const handleRemove = () => {
        setDataSteps(prevDataSteps => {
            if (prevDataSteps.length === 0) return prevDataSteps;
            const newDataSteps = prevDataSteps.slice(0, -1);
            setTimeout(() => notifyChange(newDataSteps), 0);
            return newDataSteps;
        });
    };

    const handleChange = (index: number, field: keyof IParticipantes, value: string) => {
        setDataSteps(prevDataSteps => {
            const newDataSteps = prevDataSteps.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            setTimeout(() => notifyChange(newDataSteps), 0);
            return newDataSteps;
        });
    };

    if (loading) {
        return (<LinearProgress />);
    }

    return (
        <Box padding={1}>
            <Box display={'flex'} flexDirection={smDown ? 'column' : 'row'} justifyContent={'center'} gap={2} padding={1}>
                <Button
                    variant='outlined'
                    startIcon={<Add />}
                    sx={{ borderRadius: '25px' }}
                    onClick={handleAdd}
                >
                    Adicionar
                </Button>
                <Button
                    variant='outlined'
                    startIcon={<Remove />}
                    sx={{ borderRadius: '25px' }}
                    onClick={handleRemove}
                    disabled={dataSeps.length === 0}
                >
                    Remover
                </Button>
            </Box>

            {dataSeps.map((item, index) => (
                <Box padding={1} component={Paper} sx={{ borderRadius: '25px' }} key={index} margin={2}>
                    <Grid container padding={2} spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Cargo'
                                value={item.cargo || ''}
                                name='cargo'
                                fullWidth
                                onChange={(e) => handleChange(index, 'cargo', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Empresa'
                                value={item.empresa || ''}
                                name='empresa'
                                fullWidth
                                onChange={(e) => handleChange(index, 'empresa', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Profissional'
                                value={item.profissional || ''}
                                name='profissional'
                                fullWidth
                                onChange={(e) => handleChange(index, 'profissional', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Responsabilidade'
                                value={item.responsabilidade_pae || ''}
                                name='responsabilidade_pae'
                                fullWidth
                                onChange={(e) => handleChange(index, 'responsabilidade_pae', e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};